import React from 'react'

const MenuIcon = () => (
  <div className='menu-icon'>
    <span />
    <span />
  </div>
)

export default MenuIcon



// WEBPACK FOOTER //
// ./src/components/menu-icon.js